import type { ComponentThemeStyles } from './types';

export const darkTheme: ComponentThemeStyles = {
  typography: {
    headingFont: 'Space Grotesk, system-ui, sans-serif',
    bodyFont: 'IBM Plex Sans, system-ui, sans-serif',
    baseSize: '16px',
  },
  navbar: {
    background: 'bg-gray-900',
    text: 'text-gray-100',
    brandText: 'text-white',
    linkText: 'text-gray-300',
    linkHover: 'hover:text-white',
    border: 'border-b border-gray-800',
    shadow: '',
  },
  navigationMenu: {
    background: 'bg-gray-900',
    text: 'text-gray-100',
    brandText: 'text-white',
    linkText: 'text-gray-300',
    linkHover: 'hover:text-white',
    border: 'border-b border-gray-800',
    shadow: '',
    dropdownBackground: 'bg-gray-800',
    dropdownText: 'text-gray-100',
    dropdownHover: 'hover:bg-gray-700',
  },
  hero: {
    background: 'bg-gradient-to-br from-gray-900 to-black',
    text: 'text-white',
    buttonStyle: 'bg-blue-600 text-white hover:bg-blue-700',
    overlay: '',
    pattern: true,
  },
  splitHero: {
    background: '#1f2937',
    text: '#f3f4f6',
    titleColor: '#ffffff',
    subtitleColor: '#d1d5db',
    taglineColor: '#60a5fa',
    buttonBg: '#2563eb',
    buttonText: '#ffffff',
    buttonHover: '#1d4ed8',
  },
  htmlSplit: {
    background: '#1f2937',
    text: '#f3f4f6',
    titleColor: '#ffffff',
    subtitleColor: '#d1d5db',
    taglineColor: '#60a5fa',
    buttonBg: '#2563eb',
    buttonText: '#ffffff',
    buttonHover: '#1d4ed8',
  },
  simpleHeader: {
    background: '#1e293b',
    titleColor: '#f1f5f9',
    subtitleColor: '#94a3b8',
  },
  features: {
    background: 'bg-gray-900',
    cardBg: 'bg-gray-800',
    iconColor: 'text-blue-400',
    titleColor: 'text-white',
    textColor: 'text-gray-300',
    borderRadius: 'rounded-lg',
  },
  footer: {
    background: 'bg-black',
    text: 'text-gray-200',
    mutedText: 'text-gray-500',
    border: 'border-t border-gray-800',
  },
  cta: {
    background: 'bg-gradient-to-r from-blue-900 to-purple-900',
    text: 'text-white',
    buttonStyle: 'bg-blue-600 text-white hover:bg-blue-700',
  },
  form: {
    background: 'bg-gray-900',
    inputBg: 'bg-gray-800',
    inputBorder: 'border-gray-700',
    inputText: 'text-white',
    labelColor: 'text-gray-300',
    buttonStyle: 'bg-blue-600 text-white hover:bg-blue-700',
  },
  pricing: {
    background: '#0F172A',
    cardBg: '#1E293B',
    highlightedCard: '#334155',
    titleColor: '#F1F5F9',
    subtitleColor: '#D1D5DB',
    descriptionColor: '#9CA3AF',
    planTitle: '#F1F5F9',
    planDescription: '#D1D5DB',
    priceColor: '#3B82F6',
    periodColor: '#D1D5DB',
    featureColor: '#94A3B8',
    checkColor: '#10B981',
    highlightedTitle: '#ffffff',
    highlightedPrice: '#ffffff',
    highlightedPeriod: '#dbeafe',
    highlightedFeature: '#eff6ff',
    highlightedDescription: '#dbeafe',
    highlightedCheckColor: '#93c5fd',
    highlightText: '#ffffff',
    borderColor: 'border-gray-700',
    highlightBorder: 'border-blue-600',
    highlightRing: 'ring-blue-500',
    hoverGlow: 'hover:shadow-blue-500/25',
    badgeBg: '#3b82f6',
    badgeText: 'white',
    buttonBg: '#3b82f6',
    highlightedButtonBg: '#60a5fa',
  },
  mediaText: {
    background: '#1e293b',
    titleColor: '#f1f5f9',
    textColor: '#cbd5e1',
    accentColor: '#3b82f6',
  },
  titleSubtitle: {
    background: '#1E293B',
    titleColor: '#F1F5F9',
    subtitleColor: '#94A3B8',
    buttonBg: '#3b82f6',
    buttonText: '#ffffff',
  },
  contactInfo: {
    background: '#0F172A',
    textColor: '#F1F5F9',
    titleColor: '#F1F5F9',
    accentColor: '#10B981',
  },
  faq: {
    background: '#0f172a',
    titleColor: '#f1f5f9',
    subtitleColor: '#94a3b8',
    questionColor: '#f1f5f9',
    answerColor: '#cbd5e1',
    itemBackground: '#1e293b',
    itemBorder: '#334155',
    iconColor: '#3b82f6',
  },
  testimonials: {
    background: '#1e293b',
    titleColor: '#f1f5f9',
    subtitleColor: '#94a3b8',
    cardBackground: '#0f172a',
    cardBorder: '#334155',
    quoteColor: '#cbd5e1',
    nameColor: '#f1f5f9',
    roleColor: '#94a3b8',
    starColor: '#3b82f6',
  },
  countdownTimer: {
    background: '#0f172a',
    text: '#f1f5f9',
    headline: '#f1f5f9',
    subheadline: '#94a3b8',
    number: '#3b82f6',
    label: '#94a3b8',
  },
  imageGallery: {
    background: '#0f172a',
    text: '#f1f5f9',
    title: '#f1f5f9',
    subtitle: '#94a3b8',
    caption: '#cbd5e1',
    filterButton: '#1e293b',
    filterButtonActive: '#3b82f6',
  },
  imageInfo: {
    background: '#0f172a',
    text: '#f1f5f9',
    title: '#f1f5f9',
    subtitle: '#94a3b8',
    imageBorder: '#1e293b',
    buttonBg: '#3b82f6',
    buttonText: '#ffffff',
  },
  imageCard: {
    background: '#0f172a',
    overlayColor: '#000000',
    title: '#ffffff',
    description: '#94a3b8',
    buttonBg: '#3b82f6',
    buttonText: '#ffffff',
  },
  team: {
    background: '#0f172a',
    cardBg: '#1e293b',
    nameColor: '#f1f5f9',
    roleColor: '#94a3b8',
    borderColor: '#334155',
  },
  video: {
    background: '#1e293b',
    titleColor: '#f1f5f9',
    subtitleColor: '#94a3b8',
    textColor: '#cbd5e1',
    buttonBg: '#3b82f6',
    buttonText: '#ffffff',
  },
  textBlocks: {
    background: '#0f172a',
    titleColor: '#f1f5f9',
    subtitleColor: '#94a3b8',
    textColor: '#cbd5e1',
    linkColor: '#3b82f6',
  },
  headContent: {},
  bodyEnd: {},
  htmlEmbed: {
    background: '#1e293b',
  },
  promoBanner: {
    background: '#3b82f6',
    text: '#ffffff',
    linkText: '#ffffff',
    dismissButton: '#ffffff',
  },
  logocloud: {
    background: '#1e293b',
    titleColor: '#f1f5f9',
    subtitleColor: '#94a3b8',
  },
  stats: {
    background: '#0f172a',
    titleColor: '#f1f5f9',
    subtitleColor: '#94a3b8',
    valueColor: '#38bdf8',
    labelColor: '#e2e8f0',
    descriptionColor: '#94a3b8',
  },
  blogPreview: {
    background: '#1e293b',
    titleColor: '#f1f5f9',
    subtitleColor: '#94a3b8',
    cardBackground: '#334155',
    cardTitle: '#f1f5f9',
    cardExcerpt: '#cbd5e1',
    linkColor: '#38bdf8',
  },
  conversionPopup: {
    overlay: 'rgba(0,0,0,0.7)',
    panelBackground: '#1e293b',
    headlineColor: '#f1f5f9',
    bodyTextColor: '#cbd5e1',
    buttonBackground: '#38bdf8',
    buttonText: '#0f172a',
    closeButton: '#94a3b8',
  },
  blog: {
    pageBackground: '#0f172a',
    headerBackground: '#1e293b',
    titleColor: '#f8fafc',
    descriptionColor: '#e2e8f0',
    textColor: '#e2e8f0',
    mutedTextColor: '#cbd5e1',
    linkColor: '#60a5fa',
    linkHoverColor: '#93c5fd',
    cardBackground: '#1e293b',
    cardBorder: '#334155',
    cardShadow: '0 4px 6px rgba(0, 0, 0, 0.4)',
    cardHoverShadow: '0 10px 15px rgba(59, 130, 246, 0.15)',
    postTitleColor: '#f8fafc',
    postTextColor: '#f1f5f9',
    postMetaColor: '#cbd5e1',
    tagBackground: '#334155',
    tagText: '#f1f5f9',
    tagActiveBackground: '#3b82f6',
    tagActiveText: '#ffffff',
    sidebarBackground: '#1e293b',
    sidebarTitleColor: '#f8fafc',
    paginationBackground: '#1e293b',
    paginationText: '#e2e8f0',
    paginationBorder: '#334155',
    paginationActiveBackground: '#3b82f6',
    paginationActiveText: '#ffffff',
    paginationDisabledOpacity: '0.5',
    iconColor: '#cbd5e1',
    loadingSpinnerColor: '#3b82f6',
    errorIconColor: '#64748b',
    errorButtonBackground: '#3b82f6',
    errorButtonText: '#ffffff',
  },
};
